import { OperateBoardEnum } from '../common/Constant';
/**
 * 白板API
 *
 * @export
 * @class BoardApi
 */
export default class BoardApi {
  constructor(container) {
    this.container = container;
  }

  /**
   * 设置当前涂鸦工具图形
   *
   * @param {*} id
   * @memberof DocModuler
   */
  setGraphic(id) {
    this.container.operateDoodle(OperateBoardEnum.SetGraphic, id);
  }

  /**
   * 设置当前涂鸦工具 id
   *
   * @param {*} id
   * @memberof DocModuler
   */
  setTool(id) {
    this.container.operateDoodle(OperateBoardEnum.SetTool, id);
  }

  /**
   * 设置画布背景色
   *
   * @param {*} c
   * @memberof DocModuler
   */
  setBackgroundColor(c) {
    this.container.operateDoodle(OperateBoardEnum.SetBackgroundColor, c);
  }

  /**
   * 取消选中所有已经被选的原件或者组
   *
   * @memberof DocModuler
   */
  discardActiveObject() {
    this.container.operateDoodle(OperateBoardEnum.DiscardActiveObject);
  }

  /**
   * 清空画布内容
   *
   * @memberof DocModuler
   */
  clear() {
    this.container.operateDoodle(OperateBoardEnum.Clear);
  }

  /**
   * 设置容器选中样式， 场景：根据不同角色显示不同样式
   *
   * @param {*} style
   * @memberof BoardApi
   */
  setControlStyle(style) {
    this.container.operateDoodle(OperateBoardEnum.SetControlStyle, style);
  }
}
